import React from "react";
import UserList from "./UserList";

function User() {
  return <UserList type="User" />;
}

export default User;
